import './TagNameInput.scss';

import { Rule } from 'rc-field-form/es/interface';
import { TagColorPicker } from './TagColorPicker';

import { Form, Input, Popover } from 'antd';
import { PLACEHOLDERS_COPY, TAG_NAME } from '@sonar-software/sonar-ts-constants';
import React, { useState } from 'react';

export interface TagNameInputProps {
	disabled?: boolean;
	getPopupContainer?: ((triggerNode: HTMLElement) => HTMLElement) | undefined;
	hexColor: string;
	name: string;
	onColorClick: (color: string) => void;
	onEnter?: () => void;
}

const requiredRule: Rule = {
	message: TAG_NAME.REQUIRED_MESSAGE,
	required: true
};

const lengthRule: Rule = {
	max: TAG_NAME.MAX_LENGTH,
	message: TAG_NAME.MAX_MESSAGE,
	type: 'string'
};

const rules = [ requiredRule, lengthRule ];

export const TagNameInput: React.FC<TagNameInputProps> = ({
	disabled,
	getPopupContainer,
	hexColor,
	name,
	onColorClick,
	onEnter
}) => {
	const [ isOpen, setIsOpen ] = useState(false);

	const handleOpenChange = (newOpen: boolean) => (
		disabled ?
			setIsOpen(false) :
			setIsOpen(newOpen));

	return (
		<Popover
			className='tag-name-input'
			content={ <TagColorPicker
				color={ hexColor }
				onChange={ onColorClick } /> }
			getPopupContainer={ getPopupContainer }
			onOpenChange={ handleOpenChange }
			open={ isOpen }
			placement='left'>
			<Form.Item
				name={ name }
				rules={ rules }>
				<Input
					disabled={ disabled }
					onPressEnter={ onEnter }
					placeholder={ PLACEHOLDERS_COPY.TAG_NAME }
					prefix={ <div
						className='hex-color-circle'
						style={ { backgroundColor: hexColor } } /> } />
			</Form.Item>
		</Popover>
	);
};
